// extracted by mini-css-extract-plugin
module.exports = {"ProjectDirector":"ProjectDirector_ProjectDirector__33Dru","ProjectDirector__avatar":"ProjectDirector_ProjectDirector__avatar__1gWf4"};